module.exports = __webpack_public_path__ + "img/import-files.5b14faca.svg";